import { render, staticRenderFns } from "./AcModal.vue?vue&type=template&id=bb15f606&scoped=true&"
import script from "./AcModal.vue?vue&type=script&lang=js&"
export * from "./AcModal.vue?vue&type=script&lang=js&"
import style0 from "./AcModal.vue?vue&type=style&index=0&id=bb15f606&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb15f606",
  null
  
)

component.options.__file = "AcModal.vue"
export default component.exports